<template>
  <div>
    <vg-field
        v-bind="$attrs"
        v-on="$listeners"
        :label="label"
        :value="valueText"
        :placeholder="`请选择${label}`"
        rows="1"
        readonly
        is-link
        @click="onClick"
    />
    <van-popup :value="show" position="bottom" class="vantPopup" @input="onCancel">
      <van-picker
          show-toolbar
          title="施工类型"
          :columns="columns"
          @confirm="onConfirm"
          @cancel="onCancel"/>
    </van-popup>
  </div>
</template>

<script>

import {Picker, Popup} from "vant";
import VgField from "@/components/Commons/VgField.vue";
import dpApplicationFormStore from "@/store/dp-application-form-store";

export default {
  name: "DpApplicationConstructionTypeField",
  components: {
    VgField,
    "van-picker": Picker,
    "van-popup": Popup
  },
  props: {
    label: String,
    value: null,
    disabled: Boolean,
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.input(this.columns[0].value)
      }
    }
  },
  data() {
    return {
      show: false,
      //服务商施工
      // CONSTRUCTION_SERVICE_PROVIDER
      //装修施工
      // CONSTRUCTION_DECORATION
      //临时施工
      // CONSTRUCTION_OPERATIONS
      //租户人员
      // TENANT_EMPLOYEE
      columns: [
        {
          text: '装修单元施工',
          value: 'CONSTRUCTION_DECORATION'
        },
        {
          text: '营运单元施工',
          value: 'CONSTRUCTION_OPERATIONS'
        },
        {
          text: '物业服务商施工',
          value: 'CONSTRUCTION_SERVICE_PROVIDER'
        }
      ],
    }
  },
  computed: {
    // texts() {
    //   return this.columns.reduce((texts, column) => {
    //         texts[column.value] = column.text
    //         return texts
    //       }, {}
    //   )
    // },
    valueText() {
      return this.columns.find(column => column.value === this.value)?.text;
    },
    currentColumn() {
      return this.columns.find(column => column.value === this.value);
    }
  },
  methods: {
    onClick() {
      this.show = true;
    },
    input(value) {
      dpApplicationFormStore().clearDate()
      this.$emit('input', value)
    },
    onConfirm(column) {
      this.input(column.value);
      this.show = false;
    },
    onCancel() {
      this.show = false;
    }
  }
}
</script>

<style scoped>

</style>
